<template>
    <div class="image-uploader-wrapper" :class="{'table': tableClass}">
        <ul class="image-uploader-list" tag="ul" name="list">
            <li class="image-uploader-list-item image"
              v-for="(item, index) in images"
              :class="[{'is-preview': preview},{'table': tableClass}]"
              :style="imageStyle"
              :key="item[opts.id] !== undefined ? item[opts.id] : item.uid ? item.uid : index"
              @click="onImageClick(item, index)">
                <img class="image-uploader-list-item-img" :style="imageStyle" :src="!preview ? item[opts.url] : item">
                <div class="progress-bar" v-if="!disabled && item.status !== undefined && item.percentage !== undefined">
                    <div class="progress" :class="[item.status]" :style="{width: item.percentage + '%'}"></div>
                    <p class="progress-text">{{getUploadStatus(item)}}</p>
                </div>
                <div class="image-name" v-if="item[opts.name]" :title="item[opts.name]">{{item[opts.name]}}</div>
                <div class="opar">
                  <i class="el-icon-zoom-in" @click.stop="__preview(item, index)"></i>
                  <i class="el-icon-delete" v-show="!disabled && !preview"  @click.stop="onDeleteFile(item)"></i>
                </div>
                <div class="mask"></div>
                <!-- <button title="删除" class="uploader-delete-btn" type="button"><i class="el-icon-close"></i></button> -->
            </li>
            <li class="image-uploader-list-item uploader"  :class="{'table': tableClass}" :style="imageStyle" :key="'uploader'" v-show="!disabled && !preview && images && images.length < limit">
                <el-upload
                    v-if="local"
                    class="image-uploader"
                    :class="{'table': tableClass}"
                    ref="uploader"
                    :data="data"
                    :action="serverURL"
                    :show-file-list="false"
                    :on-progress="onProgress"
                    :on-success="onSuccess"
                    :on-error="onError"
                    :multiple="limit > 1"
                    :before-upload="onBeforeUpload"
                    :auto-upload="autoUpload"
                    :on-exceed="onUploadExceedTip"
                    :disabled="disabled">
                    <i class="jc-icon icon-add image-uploader-plus"></i>
                    <p class="image-uploader-tip">上传图片</p>
                    <div class="uploader-mask"   :class="{'table': tableClass}" @mouseover.stop="onMouseover" @mouseleave.stop="onMouseleave"></div>
                    <p class="uploader-tips" :class="[tipClass]" slot="tip">{{tip}}</p>
                </el-upload>
            </li>
        </ul>
        <v-image-preview ref="preview" :options="{navbar: false}" :data="currentPic"/>
    </div>
</template>

<script>
import {addClass, removeClass} from '../utils/dom'
import VImagePreview from './image-preview.vue'
export default {
  name: 'v-image-upload',
  components: {
    VImagePreview
  },
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    },
    tableClass: {
      type: Boolean,
      default: false
    },
    width: {},
    height: {},
    limit: {
      type: Number,
      default: Infinity
    },
    statusText: {
      type: Object,
      default () {
        return {
          wait: '待上传...',
          fail: '上传失败',
          success: '上传完成'
        }
      }
    },
    beforeUpload: Function,
    autoUpload: {
      type: Boolean,
      default: true
    },
    accept: {
      type: Array,
      default () {
        return []
      }
    },
    preview: {
      type: Boolean,
      value: false
    },
    drag: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    maxSize: Number,
    tipClass: String,
    options: {
      type: Object,
      default () {
        return {}
      }
    },
    serverURL: {
      type: String,
      default () {
        return this.$FRAMEWORK.upload.action
      }
    },
    tip: String,
    local: {
      type: Boolean,
      default: true
    },
    imageStyle: {
      type: [String, Object],
      default: ''
    },
    fuwuduan: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default () {
        return this.$FRAMEWORK.upload.data
      }
    }
  },
  watch: {
    value () {
      this.images = this.value
    },
    options () {
      this.opts = Object.assign({}, this.defaultOptions, this.options)
    }
  },
  data () {
    return {
      images: [],
      currentPic: [],
      defaultOptions: {
        url: 'url',
        name: 'name',
        size: 'fileSize',
        type: 'fileType',
        id: 'id',
        lastModified: 'lastModified'
      },
      opts: {},
      visible: false
    }
  },
  mounted () {
    this.images = this.value
    if (!this.preview) this.opts = Object.assign({}, this.defaultOptions, this.options)
  },
  methods: {
    onMouseover (e) {
      if (this.$refs.uploader) addClass(this.$refs.uploader.$el, 'hover')
    },
    onMouseleave (e) {
      if (this.$refs.uploader) removeClass(this.$refs.uploader.$el, 'hover')
    },
    changeStatus (file, response) {
      let index = this.images.findIndex(img => img.uid === file.uid)
      if (index !== -1) {
        this.images[index].status = file.status
        if (file.percentage) this.images[index].percentage = file.percentage
        if (response) {
          this.images[index][this.opts.id] = response.id
          if (this.fuwuduan) this.images[index][this.opts.url] = response.fileUrl
        }
      }
    },
    getUploadStatus (file) {
      return this.statusText[file.status] ? this.statusText[file.status] : `${Math.floor(file.percentage)}%`
    },
    onProgress (event, file, fileList) {
      this.changeStatus(file)
    },
    onSuccess (response, file, fileList) {
      this.changeStatus(file, response.data)
    },
    onBeforeUpload (file) {
      if (this.images.length >= this.limit) {
        this.$emit('on-exceed', file)
        return false
      }
      if (file.type.indexOf('image') === -1) { // 检测主类型
        this.$emit('type-error', file)
        this.$tips('请上传图片', 'warning')
        return false
      }
      if (this.maxSize && file.size > this.maxSize) {
        this.$emit('size-error', file)
        this.$tips('上传图片过大', 'warning')
        return false
      }
      let ext = file.name.lastIndexOf('.') !== -1 ? file.name.substring(file.name.lastIndexOf('.') + 1) : ''
      if (!ext) {
        this.$emit('type-error', file)
        return false
      }
      if (this.accept && this.accept.length && this.accept.every(item => item.toLowerCase() !== ext.toLowerCase())) {
        this.$emit('type-error', file)
        return false
      }
      let flag = true
      if (typeof this.beforeUpload === 'function') {
        flag = this.beforeUpload(file)
      }
      if (flag) {
        this.images.push({
          [this.opts.url]: file.url ? file.url : window.URL.createObjectURL(file),
          status: 'wait',
          raw: file,
          uid: file.uid,
          [this.opts.name]: file.name,
          [this.opts.size]: file.size,
          [this.opts.type]: file.type,
          [this.opts.lastModified]: file.lastModified,
          percentage: 0,
          ext: file.name.lastIndexOf('.') !== -1 ? file.name.substring(file.name.lastIndexOf('.') + 1) : ''
        })
        this.$emit('input', this.images)
        this.$emit('change', this.images)
      }
      return flag
    },
    onError (err, file, fileList) {
      this.changeStatus(file)
    },
    onDeleteFile (file) {
      let index = this.images.findIndex(img => {
        if (img.uid && file.uid) return img.uid === file.uid
        else return img[this.opts.id] === file[this.opts.id]
      }
      )
      if (index !== -1) {
        if (this.images[index].raw) this.$refs.uploader.abort(this.images[index].raw)
        this.images.splice(index, 1)
        this.$emit('input', this.images)
        this.$emit('change', this.images)
      }
    },
    onConfirm (list) {
      this.images = list
      this.$emit('input', this.images)
    },
    onImageClick (item, index) {
      if (this.preview) {
        this.__preview(item, index)
      }
    },
    __preview (item, index) {
      this.currentPic = !this.preview ? [{name: item[this.opts.name], url: item[this.opts.url]}] : this.images.map(i => ({url: i}))
      if (!this.preview) this.$refs.preview.show()
      else {
        this.$refs.preview.show({
          initialViewIndex: index
        })
      }
    },
    onUploadExceedTip () {
      this.$message.warning('当前最多只能选择' + this.uploadNumberLimit() + '张图片上传')
    }
  }
}
</script>

<style lang="less">
.image-uploader-wrapper {
        .image-uploader-list {
            display: inline-block;
            font-size: 0;
            vertical-align: middle;
            &:before,
            &:after {
                content: ' ';
                display: block;
                clear: both;
            }
            &-item {
                position: relative;
                float: left;
                width: 148px;
                height: 148px;
                margin-right: 10px;
                margin-bottom: 10px;
                box-sizing:border-box;
                cursor: pointer;
                &-img {
                  width: 100%;
                  height: 100%;
                  position: relative;
                  object-fit: cover;
                }
                &.table {
                  width: 108px;
                  height: 108px;
                  border-radius: 4px;
                }
                &.uploader {
                    width: 148px;
                    height: 148px;
                    &.table {
                        width: 108px;
                        height: 108px;
                        border-radius: 4px;
                    }
                }
                &.uploader.table {
                  width: 108px;
                  height: 108px;
                  border-radius: 4px;
                }
                &.image {
                    background-color: #fff;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    padding: 4px;
                    // box-sizing: content-box;
                    box-sizing: border-box;
                    .uploader-delete-btn {
                        position: absolute;
                        background: #fff;
                        border: 0;
                        outline: 0;
                        border: 1px solid rgb(233, 233, 233);
                        box-sizing: border-box;
                        border-radius: 50%;
                        font-size: 12px;
                        color: #f56c6c;
                        top: -10px;
                        left: -10px;
                        z-index: 2;
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                    }
                    &:hover {
                        @keyframes icon-rotating {
                            0% {
                                transform: rotate(0deg)
                            }
                            50% {
                                transform: rotate(-10deg)
                            }
                            80% {
                                transform: rotate(10deg)
                            }
                            100% {
                                transform: rotate(0deg)
                            }
                        }
                    }
                }
                .image-name {
                    position: absolute;
                    width: calc(100% - 8px);
                    left: 4px;
                    bottom: 4px;
                    background: rgba(0, 0, 0, 0.5);
                    height: 20px;
                    text-align: center;
                    font-size: 12px;
                    color: #fff;
                    line-height: 20px;
                    white-space: nowrap;
                    overflow: hidden;
                    padding: 0 5px;
                    text-overflow: ellipsis;
                }
                .progress-bar {
                    height: 20px;
                    position: absolute;
                    left: 4px;
                    top: 4px;
                    width: calc(100% - 8px);
                    background: rgba(0, 0, 0, 0.5);
                    font-size: 12px;
                    line-height: 20px;
                    text-align: center;
                    color: #fff;
                    .progress {
                        width: 0;
                        height: 20px;
                        background: rgba(64, 158, 255, 0.8);
                        position: absolute;
                        left: 0;
                        top: 0;
                        z-index: 1;
                        transition: width .2s ease-in-out;
                        &.fail {
                            background: rgba(245, 108, 108, 0.8);
                            width: 100%;
                        }
                        &.success {
                            background: rgba(103, 194, 58,0.8);
                        }
                    }
                    .progress-text {
                        font-size: 12px;
                        color: #fff;
                        z-index: 2;
                        position: relative;
                    }
                }
                .opar {
                  position: absolute;
                  font-size: 14px;
                  left: 50%;
                  top: 50%;
                  visibility: hidden;
                  opacity: 0;
                  font-size: 18px;
                  transition: all .3s;
                  z-index: 100;
                  transform: translate(-50%, -50%);
                  color: #fff;
                  i + i {
                    margin-left: 10px;
                  }
                }
                .mask {
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 99;
                  opacity: 0;
                  background: rgba(0, 0, 0, 0.6);
                }
                transition: all .3s;
                &:not(.is-preview) {
                  &:hover {
                    .mask {
                      opacity: 1;
                    }
                    .opar {
                      visibility: visible;
                      opacity: 1;
                    }
                  }
                }
            }
        }
        .image-uploader {
            position: relative;
            display: inline-flex;
            cursor: pointer;
            width: 148px;
            height: 148px;
            background: rgb(249, 249, 249);
            border: 1px dashed rgb(233, 233, 233);
            color: #ccc;
            align-items: center;
            justify-content: center;
            vertical-align: middle;
            &.table {
              width: 108px;
              height: 108px;
              border-radius: 4px;
            }
            &-plus {
                font-size: 22px;
                color: rgb(204, 204, 204);
                font-style: normal;
                font-weight: bold;
                line-height: 20px;
            }
            &-tip {
                font-size: 14px;
                font-weight: 403;
                color: rgb(204, 204, 204);
                line-height: 1;
            }
            .uploader-mask {
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                right: 0;
            }
            &.hover {
                background: #fff;
                border-color: #911B21;
                color: #911B21;
                .image-uploader-plus {
                    color: #911B21;
                }
                .image-uploader-tip {
                    color: #911B21;
                }
            }
            .uploader-tips {
                position: absolute;
                bottom: 2px;
                right: -5px;
                transform: translateX(100%);
                font-size: 12px;
                color: #999;
                display: inline-block;
                line-height: 1;
                width: max-content;
                cursor: default;
            }
        }
    }
    .list-enter-active, .list-leave-active {
        transition: all 1s;
    }
    .list-enter {
        opacity: 0;
        transform: translateY(30px);
    }
    .list-leave-to {
        opacity: 0;
        transform: translateY(-30px);
    }
</style>



// WEBPACK FOOTER //
// src/components/framework/widgets/image-upload.vue